module.exports = __webpack_public_path__ + "static/media/astra.5db9ec57.png";